import {
  useState,
  useEffect,
  useCallback,
} from 'react';
import { Api } from '@shell/shell-ui';

export default function useNotifications() {
  const [notificationsPage, setNotificationsPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [notificationsList, setNotificationsList] = useState([]);

  const loadNotifications = useCallback(async (page = notificationsPage) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page,
        size: '10',
        sort: 'notification.createdAt,desc',
      });
      const { data } = await Api.get(`/notification-user/current-user?${ queryParams.toString() }`);
      if (page === 0) {
        setNotificationsList(data.content);
      } else {
        setNotificationsList((prevNotificationList) => (
          [...prevNotificationList, ...data.content]
        ));
      }
      setNotificationsPage(page);
      setTotalPages(data.totalPages);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log({ e });
    } finally {
      setLoading(false);
    }
  }, [notificationsPage]);

  useEffect(() => {
    loadNotifications();
    const interval = setInterval(loadNotifications, 60 * 1000); // fetch notifications every 1 minute

    return () => clearInterval(interval);
  }, [loadNotifications]);

  return {
    loading,
    totalPages,
    notificationsList,
    notificationsPage,
    loadMoreNotifications: loadNotifications,
  };
}
